export const TIMEZONE_OPTIONS = [
  { iana: 'UTC',                  label: 'UTC (UTC+0)' },
  { iana: 'Africa/Lagos',         label: 'Lagos (UTC+1)' },
  { iana: 'Africa/Nairobi',       label: 'Nairobi (UTC+3)' },
  { iana: 'Africa/Johannesburg',  label: 'Johannesburg (UTC+2)' },
  { iana: 'Asia/Kolkata',         label: 'India (UTC+5:30)' },
  { iana: 'Asia/Dhaka',           label: 'Dhaka (UTC+6)' },
  { iana: 'Asia/Kuala_Lumpur',    label: 'Kuala Lumpur (UTC+8)' },
  { iana: 'Asia/Singapore',       label: 'Singapore (UTC+8)' },
  { iana: 'Asia/Bangkok',         label: 'Bangkok (UTC+7)' },
  { iana: 'Asia/Manila',          label: 'Manila (UTC+8)' },
  { iana: 'Europe/London',        label: 'London (UTC+0/+1)' },
  { iana: 'America/New_York',     label: 'New York (UTC-5/-4)' },
  { iana: 'America/Chicago',      label: 'Chicago (UTC-6/-5)' },
  { iana: 'Australia/Sydney',     label: 'Sydney (UTC+10/+11)' },
  { iana: 'Pacific/Auckland',     label: 'Auckland (UTC+12/+13)' },
] as const;
